import React, { useEffect, useState } from 'react';
import { CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://tufenixdigital.store/cart/54032549216620:1';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'success';
};
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 54,
    seconds: 6
  });
  const [isPageVisible, setIsPageVisible] = useState(() => document.visibilityState === 'visible');
  useEffect(() => {
    const updateVisibility = () => setIsPageVisible(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', updateVisibility);
    return () => document.removeEventListener('visibilitychange', updateVisibility);
  }, []);
  useEffect(() => {
    if (!isPageVisible) return;
    const timer = window.setInterval(() => {
      setTimeLeft(previous => {
        if (previous.seconds > 0) return {
          ...previous,
          seconds: previous.seconds - 1
        };
        if (previous.minutes > 0) return {
          ...previous,
          minutes: previous.minutes - 1,
          seconds: 59
        };
        if (previous.hours > 0) return {
          hours: previous.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return previous;
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, [isPageVisible]);
  return <div className="inline-flex items-start justify-center gap-2 font-display font-bold" aria-label={`${timeLeft.hours} horas, ${timeLeft.minutes} minutos y ${timeLeft.seconds} segundos restantes`} data-id="element-208">
      <TimeBox value={timeLeft.hours} label="hs" data-id="element-209" />
      <span className="pt-2 text-2xl text-red-600 md:pt-3 md:text-4xl" aria-hidden="true" data-id="element-210">
        :
      </span>
      <TimeBox value={timeLeft.minutes} label="min" data-id="element-211" />
      <span className="pt-2 text-2xl text-red-600 md:pt-3 md:text-4xl" aria-hidden="true" data-id="element-212">
        :
      </span>
      <TimeBox value={timeLeft.seconds} label="seg" data-id="element-213" />
    </div>;
}
function TimeBox({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-214">
      <span className="min-w-[60px] rounded-xl bg-red-600 px-3 py-2 text-center text-2xl tabular-nums text-white shadow-sm md:min-w-[72px] md:text-4xl" data-id="element-215">
        {String(value).padStart(2, '0')}
      </span>
      <span className="mt-1 text-xs font-semibold uppercase tracking-wider opacity-70" data-id="element-216">
        {label}
      </span>
    </div>;
}
export function TrustBar({
  tone = 'light'
}: {
  tone?: 'light' | 'dark';
}) {
  const color = tone === 'dark' ? 'text-slate-200' : 'text-brand-gray';
  return <div className={`flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm font-medium ${color}`} data-id="element-217">
      <span className="flex items-center gap-1.5" data-id="element-218">
        <ShieldCheckIcon className="h-4 w-4" data-id="element-219" /> Garantía 7 días
      </span>
      <span className="flex items-center gap-1.5" data-id="element-220">
        <LockKeyholeIcon className="h-4 w-4" data-id="element-221" /> Pago seguro
      </span>
      <span className="flex items-center gap-1.5" data-id="element-222">
        <CreditCardIcon className="h-4 w-4" data-id="element-223" /> Mercado Pago
      </span>
    </div>;
}
export function Button({
  children,
  className = '',
  variant = 'primary'
}: ButtonProps) {
  const theme = variant === 'success' ? 'bg-brand-green hover:bg-green-800 focus-visible:ring-brand-green' : 'bg-brand-orange hover:bg-[#dd6800] focus-visible:ring-brand-orange';
  return <a href={CHECKOUT_URL} className={`flex w-full items-center justify-center rounded-2xl border border-white/25 px-6 py-4 text-center font-display text-lg font-bold text-white shadow-[0_8px_20px_rgba(245,124,0,0.28)] transition-colors focus-visible:outline-none focus-visible:ring-4 ${theme} ${className}`} data-id="element-224">
      {children}
    </a>;
}
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setIsVisible(window.scrollY > 620);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-orange-200 bg-white/95 p-3 shadow-[0_-8px_30px_rgba(13,59,110,0.12)] md:hidden" data-id="element-225">
      <a href={CHECKOUT_URL} className="block w-full rounded-xl bg-brand-orange px-4 py-3 text-center font-display font-bold text-white focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-orange-300" data-id="element-226">
        Quiero mi kit — $390 UYU
      </a>
    </div>;
}